import { getResolvedPid } from "../../features/attribution/runtime";
import { getClientPlatformInfo } from "../../features/clientEnv";

declare global {
  interface Navigator {
    standalone?: boolean;
  }
}

export enum GUIDE_STEP {
  //任务
  Quest = 1,
}

export class sys {

  /** Indicate the running os name */
  static get os(): OSType {
    return getClientPlatformInfo().os;
  }


  /**设备类型 1ios-h5 2Android-h5 3pc 4ios-app 5android-app*/
  static get device(): number {
    return getClientPlatformInfo().device;
  }

  /**渠道挂靠id */
  static get pid(): string {
    sys._init();
    return sys._pid;
  }

  /**下级代理挂靠id */
  public static get inviteCode(): string {
    sys._init();
    return sys._inviteCode;
  }

  public static setInviteCode(rid: string | null) {
    if (rid) {
      sys._inviteCode = rid;
      localStorage.setItem("rid", sys._inviteCode);
    } else {
      sys._inviteCode = null;
      localStorage.removeItem("rid");
    }
  }


  /**打开连接 */
  static openUrl(url: string): WindowProxy | null {
    console.log("openUrl", url);
    return window.open(url, "_blank");
  }

  private static _isInit = false;
  private static _pid: string;
  private static _inviteCode: string;
  private static _token: any;

  public static get token() {
    return sys._token;
  }

  public static set token(token) {
    sys._token = token;
  }

  private static _init() {
    if (this._isInit) {
      return;
    }


    this._isInit = true;

    sys._pid = getResolvedPid();

    sys._inviteCode = getUrlParam("rid") || localStorage.getItem("rid");

    if (sys._inviteCode) {
      localStorage.setItem("rid", sys._inviteCode);
    }
  }
}

export function getUrlParam(name) {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const r = window.location.search.substring(1).match(reg);
  if (r != null) {
    return decodeURI(r[2]);
  } else {
    return null;
  }
}

export function parseQueryString(queryString) {
  const params = {};
  const keyValuePairs = queryString.split("&");

  for (const pair of keyValuePairs) {
    const [key, value] = pair.split("=");
    if (key && value) {
      params[key] = decodeURIComponent(value);
    }
  }
  return params;
}

export type OSType = "IOS" | "ANDROID" | "WINDOWS" | "UNKNOWN";
